import { GQLCategoryFaQsFragment } from '@theprintbar/graphql';
import { BrandColours, cn } from '@theprintbar/shared';
import { Accordion, MediumArrowIcon, OutlineButton, RichText } from '@theprintbar/ui';
import { useState } from 'react';

interface CategoryFAQsProps {
	content: GQLCategoryFaQsFragment;
}

export const CategoryFAQs = ({ content }: CategoryFAQsProps) => {
	const [activeLink, setActiveLink] = useState<string | undefined | null>();
	const categories = Array.from(new Set(content?.categoryFAQs?.structure?.map(item => item?.category).filter(Boolean)));

	const faqsByCategory = activeLink
		? content?.categoryFAQs?.structure?.reduce((acc, item) => {
				item?.category === activeLink ? acc.push(item) : null;
				return acc;
		  }, [] as any[])
		: content?.categoryFAQs?.structure || [];

	return (
		<div className="mx-4 lg:mx-8 my-20 lg:my-32">
			<div className="flex flex-col lg:gap-32 lg:flex-row mt-5">
				{/* Category lists on the left */}
				<div className="flex flex-row lg:flex-col gap-2.5 lg:gap-5 flex-wrap">
					<h4 className="hidden lg:block font-display font-normal text-2xl lg:text-3xl normal-case lg:mb-8 whitespace-nowrap">
						{content.categoryFAQsContainer.structure?.title || "FAQ's"}
					</h4>
					{categories?.map(category => (
						<OutlineButton
							key={category}
							onClick={() => setActiveLink(category)}
							style={{
								backgroundColor: activeLink === category ? BrandColours.BrightBlue || BrandColours.BrightBlue : '',
							}}
							className={cn(
								'py-2.5 px-5 lg:py-3 lg:px-6 flex justify-center items-center w-max font-display font-light hover:text-blue hover:bg-blue-bright',
							)}
						>
							<div className="text-sm lg:text-xl">{category}</div>
						</OutlineButton>
					))}
				</div>

				<div className="flex flex-col w-full h-fit">
					<RichText className="space-y-2 hidden lg:block lg:max-w-xl" />
					<div className="w-full max-w-5xl last:border-b last:border-blue">
						{faqsByCategory?.map((item, index) => (
							<Accordion
								key={index + item?.category}
								title={<h5 className="py-3 text-lg lg:text-xl font-light font-display">{item?.title}</h5>}
								openIcon={MediumArrowIcon}
								closeIcon={MediumArrowIcon}
								openIconClass="fill-blue w-3 h-3 rotate-180"
								closeIconClass="fill-blue w-3 h-3"
							>
								<RichText className="max-w-4xl" content={item?.text?.content} />
							</Accordion>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};
